import createReactComponent from '../createReactComponent';
var CloudSun = createReactComponent('CloudSun', [['path', {
  d: 'M12 2v2',
  key: 'tus03m'
}], ['path', {
  d: 'M5.22 5.22l1.42 1.42',
  key: '1pym8u'
}], ['path', {
  d: 'M20 12h2',
  key: '1q8mjw'
}], ['path', {
  d: 'M15.97 12.5A4 4 0 009.5 8.88',
  key: '39zu4u'
}], ['path', {
  d: 'M13.63 22A3.3 3.3 0 0017 18.79a3.3 3.3 0 00-3.38-3.22h-1.34A5.23 5.23 0 007.25 12 5.13 5.13 0 002 17c0 2.76 2.35 5 5.25 5h6.38z',
  key: '1g9o7i'
}], ['path', {
  d: 'M17.36 6.64l1.42-1.42',
  key: 'i23w4h'
}]]);
export default CloudSun;